
import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import { getSupercategoryDetails, upload } from "../../store/actions/vendor/Vendor";
import { Table, Button } from "reactstrap";
import { connect } from "react-redux";
import { addSuperCategory, updateSuperCategory } from "../../store/actions/admin/Admin";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import close_icon from './close_icon.png';

const styles = {
  typo: {
    paddingLeft: "25%",
    marginBottom: "40px",
    position: "relative",
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: "10px",
    color: "#c0c1c2",
    display: "block",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "13px",
    left: "0",
    marginLeft: "20px",
    position: "absolute",
    width: "260px",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  }
};

const useStyles = makeStyles(styles);

const SuperCategory = (props) => {
  const classes = useStyles();
  const [imageUploadMessage, updateImageUploadMessage] = useState("");
  const [coverImageUploadMessage, updateCoverImageUploadMessage] = useState("");
  const [superCategory, updateSuperCategory] = useState({ isResturant: false, isPicknDrop: false, isFlights: false });
  const [isEdit, updateIsEdit] = useState(false);

  const onChange = (event) => {
    let tempSuperCategory = { ...superCategory };
    tempSuperCategory[event.target.name] = event.target.value;
    updateSuperCategory(tempSuperCategory);
  };

  useEffect(() => {
    const { superCategoryId } = props?.match?.params;
    if (superCategoryId) {
      updateIsEdit(!!superCategoryId);
      props.getSupercategoryDetails(superCategoryId);
    }
  }, []);

  useEffect(() => {
    if (props?.superCategoryDetails && isEdit) {
      const superCategory = {
        superCategoryId: props.superCategoryDetails.id,
        name: props.superCategoryDetails.name,
        icon: props.superCategoryDetails.icon,
        priority: props.superCategoryDetails.priority,
        isResturant: props.superCategoryDetails.isResturant,
        isPicknDrop: props.superCategoryDetails.isPicknDrop,
        isFlights: props.superCategoryDetails.isFlights,
        coverImages: props.superCategoryDetails.coverImages,
        eventTag: props.superCategoryDetails.eventTag,
      };
      updateSuperCategory(superCategory);
    }
  }, [props?.superCategoryDetails])

  const onUpload = (event) => {
    updateImageUploadMessage("Uploading the file, please wait...");

    let data = new FormData();
    data.append("files", event.target.files[0]);
    props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          updateImageUploadMessage("File uploaded successfully.");
          let tempSuperCategory = { ...superCategory };
          tempSuperCategory.icon = `${response.data.uploads[0].path}`;
          updateSuperCategory(tempSuperCategory);
        } else {
          updateImageUploadMessage("Please, try Again");
        }
      })
      .catch((error) => {
        updateImageUploadMessage(
          "An error occurred while executing the query. Please try Again"
        );
      });
  };
  const onCoverUpload = (event) => {
    updateCoverImageUploadMessage("Uploading the file, please wait...");

    let data = new FormData();
    data.append("files", event.target.files[0]);
    props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          updateCoverImageUploadMessage("File uploaded successfully.");
          let tempSuperCategory = { ...superCategory };
          if (tempSuperCategory.coverImages) {
            tempSuperCategory.coverImages[tempSuperCategory.coverImages ? tempSuperCategory.coverImages.length : 0] = `${response.data.uploads[0].path}`;
          } else {
            tempSuperCategory.coverImages = []
            tempSuperCategory.coverImages[0] = `${response.data.uploads[0].path}`;
          }
          updateSuperCategory(tempSuperCategory);
        } else {
          updateCoverImageUploadMessage("Please, try Again");
        }
      })
      .catch((error) => {
        updateCoverImageUploadMessage(
          "An error occurred while executing the query. Please try Again"
        );
      });
  };
  const onSubmit = (event) => {
    event.preventDefault();
    if (isEdit) {
      props.updateSuperCategory(superCategory).then((data) => {
        if (data) {
          props.history.push("/admin/super-categories");
        }
      });
    } else {
      props.addSuperCategory(superCategory).then((data) => {
        if (data) {
          props.history.push("/admin/super-categories");
        }
      });
    }
  };

  const changeIsRestaurant = () => {
    const tempSuperCategory = { ...superCategory };
    tempSuperCategory.isResturant = !tempSuperCategory.isResturant;
    updateSuperCategory(tempSuperCategory);
  };

  const changeIsPickNDrop = () => {
    const tempSuperCategory = { ...superCategory };
    tempSuperCategory.isPicknDrop = !tempSuperCategory.isPicknDrop;
    updateSuperCategory(tempSuperCategory);
  };

  const changeIsFlights = () => {
    const tempSuperCategory = { ...superCategory };
    tempSuperCategory.isFlights = !tempSuperCategory.isFlights;
    updateSuperCategory(tempSuperCategory);
  };

  const deleteCoverImage = (index) => {
    let tempSuperCategory = { ...superCategory };
    tempSuperCategory.coverImages.splice(index, 1);
    updateSuperCategory(tempSuperCategory);
  }

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Add a Supercategory</h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <CardBody>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={5}>
            <CustomInput
              labelText="Supercategory Name"
              value={superCategory?.name}
              onChange={onChange}
              name="name"
              id="name"
              labelProps={{
                shrink: isEdit
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={5}>
            <CustomInput
              labelText="Priority"
              type="number"
              value={superCategory?.priority}
              onChange={onChange}
              name="priority"
              id="priority"
              labelProps={{
                shrink: isEdit
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={5}>
            <CustomInput
              labelText="Supercategory Icon"
              id="icon"
              type="file"
              name="icon"
              accept="image/png, image/jpeg, image/jpg"
              onChange={onUpload}
              labelProps={{
                shrink: isEdit
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <p style={{ color: "#000" }}>{imageUploadMessage}</p>
          <GridItem xs={12} sm={12} md={3} style={{ display: "flex", alignItems: "flex-end" }}>
            <CustomInput
              labelText="Event Tag"
              value={superCategory?.eventTag}
              onChange={onChange}
              name="eventTag"
              id="eventTag"
              labelProps={{
                shrink: isEdit
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3} style={{ display: "flex", alignItems: "flex-end" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={superCategory?.isResturant}
                  onChange={changeIsRestaurant}
                  name="isRestaurant"
                />
              }
              label="Is Restaurant"
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3} style={{ display: "flex", alignItems: "flex-end" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={superCategory?.isPicknDrop}
                  onChange={changeIsPickNDrop}
                  name="isPicknDrop"
                />
              }
              label="Is Pick And Drop"
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3} style={{ display: "flex", alignItems: "flex-end" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={superCategory?.isFlights}
                  onChange={changeIsFlights}
                  name="isFlights"
                />
              }
              label="Is Flights"
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} >
            <br></br>
            <h5 style={{ fontWeight: 'bold' }}>Cover images</h5>
            <CustomInput
              labelText="Upload Cover Image"
              id="icon"
              type="file"
              name="icon"
              accept="image/png, image/jpeg, image/jpg"
              onChange={onCoverUpload}
              labelProps={{
                shrink: isEdit
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
            <p style={{ color: "#000" }}>{coverImageUploadMessage}</p>
            <GridContainer>
              {superCategory.coverImages && superCategory.coverImages.map((coverImage, index) => {
                return (<GridItem xs={12} sm={12} md={3} >
                  <div style={{
                    display: 'inline-block',
                    position: 'relative'
                  }}>
                    <img src={coverImage} style={{ height: "70px" }} />
                    <img onClick={() => deleteCoverImage(index)} width={20} style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      cursor: 'pointer'
                    }} src={close_icon} />
                  </div>
                </GridItem>)
              })}
            </GridContainer>

          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter>
        <Button
          type="submit"
          onClick={onSubmit}
          style={{
            color: "#fff",
            backgroundColor: "#9c27b0",
            boxShadow:
              "0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
          }}
        >
          {isEdit ? 'Update' : 'Edit'} Supercategory
        </Button>
      </CardFooter>
      <br /> <br />
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Icon</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>1</th>
            <td>{superCategory.name}</td>
            <td>
              <img src={superCategory.icon} style={{ height: "70px" }} />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};


const mapStateWithProps = (state) => ({
  superCategoryDetails: state.admin.superCategoryDetails,
});

const mapDispatchWithProps = (dispatch) => {
  return {
    getSupercategoryDetails: (superCategoryId) =>
      dispatch(getSupercategoryDetails(superCategoryId)),
    updateSuperCategory: (categoryData) =>
      dispatch(updateSuperCategory(categoryData)),
    addSuperCategory: (categoryData) =>
      dispatch(addSuperCategory(categoryData)),
    upload: (data) => dispatch(upload(data)),
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(SuperCategory);

